module.exports = __webpack_public_path__ + "img/icon-w-9.png";